export const MDA_OPTIONS = [
  {
    key: 'eva',
    name: 'Na escala de dor EVA de 0 a 100, o paciente em ≤15?Dor na coluna cervical',
  },
  {
    key: 'global_activity_desease',
    name: 'Na avaliação global da atividade de sua doença de 0 a 100, o paciente está em ≤ 20?',
  },
  {
    key: 'haq',
    name: 'O HAQ do paciente é ≤ 0,5?',
  },
  {
    key: 'joints_paintful',
    name: 'A contagem de articulações dolorosas é ≤1?',
  },
  {
    key: 'edema_joint_count',
    name: 'A contagem de articulações edemaciadas é ≤1?',
  },
  {
    key: 'pasi_bsa',
    name: 'PASI ≤ 1 ou BSA ≤ 3',
  },
  {
    key: 'entesite',
    name: 'Entesite ≤ 1?',
  },
]
